var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiletypeHtml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1459,
    height: 1100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#b1b1b1",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 953,
    y: 555,
    width: 1459,
    height: 1394
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1126,
    y: 555,
    width: 1113,
    height: 794
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1126,
    y: 555,
    width: 1113,
    height: 794
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1126,
    y: 555,
    width: 1113,
    height: 1113
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-953 -555)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M973.625 312.951 973.625 764.991 904.081 764.991 904.081 312.951 764.991 312.951C707.379 312.951 660.674 266.247 660.674 208.634L660.674 69.5447 278.179 69.5447C239.77 69.5447 208.634 100.681 208.634 139.089L208.634 764.991 139.089 764.991 139.089 139.089C139.089 62.2724 201.362-1.5442e-14 278.179-1.5442e-14L660.674 0 973.625 312.951ZM296.538 824.104 296.538 1102.21 241.529 1102.21 241.529 983.014 124.485 983.014 124.485 1102.21 69.5447 1102.21 69.5447 824.104 124.554 824.104 124.554 937.184 241.529 937.184 241.529 824.104 296.469 824.104ZM453.083 870.143 453.083 1102.21 397.865 1102.21 397.865 870.143 319.071 870.143 319.071 824.104 532.156 824.104 532.156 870.143 453.083 870.143ZM604.413 1102.21 604.413 917.224 607.055 917.224 673.262 1067.37 709.147 1067.37 774.936 917.155 777.579 917.155 777.579 1102.21 827.303 1102.21 827.303 824.104 771.667 824.104 692.387 1004.64 690.578 1004.64 611.297 824.104 555.314 824.104 555.314 1102.21 604.413 1102.21ZM931.968 1055.34 1049.92 1055.34 1049.92 1102.21 876.958 1102.21 876.958 824.104 931.898 824.104 931.898 1055.34Z",
    fillRule: "evenodd",
    transform: "matrix(1.00026 0 0 1 1126 555)"
  })))), /*#__PURE__*/React.createElement("text", {
    fill: "#51c0a3",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 367,
    transform: "matrix(1 0 0 1 1173.7 1645)"
  }, "HTML"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiletypeHtml);
export default __webpack_public_path__ + "static/media/filetype-html.7a3a6a2c185e72cd8bddee4f0b8d714b.svg";
export { ForwardRef as ReactComponent };